import {useNavigate} from 'react-router-dom';
import useGetNotificationCount from '../../../../services/hookService/getNotificationCount/useGetNotificationCount';

const NotificationHeaderIcon = () => {
  const navigate = useNavigate();
  const {notificationCount, isLoading} = useGetNotificationCount();

  const displayCount = notificationCount > 99 ? '99+' : notificationCount;

  return (
    <div
      className="relative self-end cursor-pointer"
      onClick={() => {
        navigate('/my-notifications');
      }}
    >
      <i
        className={`icon-size24135 text-[25px] text-gray-700 ${
          isLoading ? 'animate-pulse' : ''
        }`}
      />

      {notificationCount > 0 && (
        <span className="absolute flex items-center justify-center px-1 text-xs text-white -translate-x-1/2 bg-red-600 rounded-full size-4 left-full -top-2">
          {displayCount}
        </span>
      )}
    </div>
  );
};

export default NotificationHeaderIcon;
